export const summaryDataCacheKey = 'summaryData';
export const tallyIdKey = 'tallyId';
export const ofwPromoSeenKey = 'ofwPromoSeen';
